import React, { Component } from 'react';
import { connect } from 'react-redux';
import ParkingSpotInfoDetail from '../../components/MapInfoBar/ParkingSpotInfoDetail';
import AvatarImage from '../AvatarImage';


class ParkingSpotInfoDetailMobile extends Component {

  moreAttendeesString(attendeesCount) {
    if(attendeesCount > 1) {
      return (
        <span className="spot-etc">
          {`+${attendeesCount - 1} more...`}
        </span>
      );
    } else {
      return "";
    }
  }

  resizedAvatar(avatar) {
    return <AvatarImage entity="spotAttendee" avatar={avatar} />;
  }

  emptyAvatar(attendeesCount) {
    return <div className="icon-profile-empty-20"/>;
  }

  spotSummary(attendees) {
    if(attendees.length > 0) {
      const attendeesCount = attendees.length;
      const defaultAttendee = attendees[0];
      let className = "spot-driver";
      if(attendeesCount > 1) {
          if(attendeesCount == 2) {
              className += " spot-driver-multiple spot-driver-multiple-double";
          }else{
              className += " spot-driver-multiple";
          }
      }
      return (
        <div className="spot-head">
          <div className={className}>
            { attendeesCount > 1 && <div className="icon-profile-empty-multiple" /> }
            <AvatarImage entity="spotAttendee" avatar={defaultAttendee.avatar} />
            <span className="spot-names">
                {`${defaultAttendee.firstName} ${defaultAttendee.lastName} `}
                {this.moreAttendeesString(attendeesCount)}
            </span>
          </div>
        </div>
      );
    } else {
      return <div />;
    }

  }

  render() {
    const { attendees, spotInfoDetailedView } = this.props;

    if(spotInfoDetailedView) {
      return <ParkingSpotInfoDetail attendees={attendees} />;
    } else {
      return this.spotSummary(attendees);
    }
  }

}

const mapStateToProps = (state) => {
  return {
    spotInfoDetailedView: state.navOptions.spotInfoDetailedView
  };
};

export default connect(mapStateToProps)(ParkingSpotInfoDetailMobile);



// WEBPACK FOOTER //
// ./src/containers/MapInfoBar/ParkingSpotInfoDetailMobile.js